<template>
  <v-snackbar v-model="dialog.show" :multi-line="true" centered :timeout="null">
    <v-alert outlined :type="dialogType(dialog.custom)">
      {{ title() }}
    </v-alert>
    <br />
    {{ dialog.content }}
    <br />
    <v-btn color="grey" text @click="clickOk">
      {{ titleButtonOk() }}
    </v-btn>
    <v-btn color="grey" text @click="clickCancel">
      {{ titleButtonCancel() }}
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: "SnackBar",
  props: ["dialog"],
  data() {
    return {};
  },
  methods: {
    title() {
      return this.dialog.custom == "confirm"
        ? this.translatedText("dialogConfirmation")
        : this.dialog.custom == "error"
        ? this.translatedText("dialogError")
        : this.translatedText("dialogInformation");
    },
    showButtonOk() {
      return true;
    },
    showButtonCancel() {
      return this.dialog.custom == "confirm";
    },
    titleButtonOk() {
      return this.dialog.custom == "confirm" ? this.translatedText("confirmText") : "OK";
    },
    titleButtonCancel() {
      return this.translatedText("dialogCancel");
    },
    clickOk() {
      this.$emit("close-dialog", { result: true });
    },
    clickCancel() {
      this.$emit("close-dialog", { result: false });
    },
  },
};
</script>

<style>
</style>